import { Box, Text } from '@qga/roo-ui/components';

import Inclusions from '@/v2/components/ui/Inclusions';
import { Inclusion } from '@/v2/services/sanity/types/api/parsedResponse';

interface Props {
  inclusions: Inclusion[];
}

const PackageInclusions = ({ inclusions }: Props) => (
  <Box data-testid="PACKAGE_OPTION_INCLUSIONS">
    <Text as="div" mb="3" fontSize="sm">
      Package inclusions:
    </Text>
    <Inclusions inclusions={inclusions} color="#323232" />
  </Box>
);

export default PackageInclusions;
